import { ComboboxContext } from '@/components/Combobox/context/ComboboxContext';
import {
  ComboboxContextValue,
  ComboboxOptionBase,
} from '@/components/Combobox/types';
import { useContext } from 'react';

export function useComboboxContext<T extends ComboboxOptionBase>() {
  const context = useContext(ComboboxContext);

  if (!context) {
    throw new Error(
      'useComboboxContext must be used within a ComboboxContextProvider',
    );
  }

  return context as unknown as ComboboxContextValue<T>;
}
